import { useEffect, useState } from 'react';

export default function useMapZoom() {
  const [zoom, setZoom] = useState(null);

  useEffect(() => {
    if (!window.map) return;
    setZoom(window.map.getZoom());

    const handleZoom = () => {
      setZoom(window.map.getZoom());
    };

    window.map.on('zoom', handleZoom);

    return () => {
      if (!window.map) return;
      window.map.off('zoom', handleZoom);
    };
  }, [window.map]);

  return zoom;
}
